import { Flex, Text } from '@chakra-ui/react';
import {
  ArrowRightOutline,
  CupOutline,
  StarOutline,
  formatCurrency,
  RecognitionOverviewResponse,
  YellowWarningBold,
} from '@aslanpay/portal-common-lib';
import getPointsValue from 'app/utils/points';

import { RecognitionDestination } from '../../destinations';

interface RecognitionStatCardsProps {
  data: RecognitionOverviewResponse;
  onNavigate: (destination: RecognitionDestination) => void;
}

interface StatCardItemProps {
  title: string;
  value: number;
  icon: React.ReactNode;
  showArrow?: boolean;
  onClick: () => void;
}

function StatCardItem({ title, value, icon, showArrow = false, onClick }: StatCardItemProps) {
  return (
    <Flex
      as="button"
      flex="1"
      textAlign="left"
      onClick={onClick}
      bg="brand.lightGray2"
      border="1px solid"
      borderColor="brand.lightGray1"
      borderRadius="8px"
      h="100px"
      p="15px 20px"
      gap="16px"
      alignItems="center"
      cursor="pointer"
      _active={{ transform: 'scale(0.98)' }}
    >
      <Flex
        bg="brand.white"
        borderRadius="10px"
        p="10px"
        boxShadow="0px 12px 11px rgba(36, 54, 70, 0.06)"
        flexShrink={0}
      >
        {icon}
      </Flex>
      <Flex flexDir="column" gap="3px" flex="1">
        <Text textStyle="smallMedium" color="brand.darkGray">
          {title}
        </Text>
        <Text as="h3" textStyle="h3" color="brand.darkPurple" fontWeight="bold">
          {value.toLocaleString()}
        </Text>
      </Flex>
      {showArrow && <ArrowRightOutline boxSize="24px" color="brand.purple" flexShrink={0} />}
    </Flex>
  );
}

function RecognitionStatCards({ data, onNavigate }: RecognitionStatCardsProps) {
  const { totalRecognitions, pointsGiven, escalations } = data;

  return (
    <Flex w="full" gap="19px" flexDir={{ base: 'column', md: 'row' }}>
      <StatCardItem
        title="Total recognitions"
        value={totalRecognitions}
        icon={<CupOutline boxSize="40px" color="brand.purple" />}
        onClick={() => onNavigate('theRoar')}
      />
      <StatCardItem
        title={`Points given (worth ${formatCurrency(getPointsValue(pointsGiven))})`}
        value={pointsGiven}
        icon={<StarOutline boxSize="40px" color="brand.purple" />}
        onClick={() => onNavigate('walletsAndPots')}
      />
      <StatCardItem
        title="Escalations (waiting 3+ days)"
        value={escalations}
        icon={<YellowWarningBold boxSize="40px" />}
        showArrow
        onClick={() => onNavigate('approvals')}
      />
    </Flex>
  );
}

export default RecognitionStatCards;
